module.exports = __webpack_public_path__ + "img/mentor6.9d6d61e.jpg";